const onDemandBucketBase = "https://emun-on-demand.s3.amazonaws.com";
const clipartClient = "mw141";
const DEFAULT_API_PATH = SERVICE_URL || "/service/";

export default class AppConfig {
  constructor() {
    //console.debug("serviceUrl", { DEFAULT_API_PATH, process });
    this.serviceUrl = DEFAULT_API_PATH;
    this.defaultProductSize = "small";
    this.defaultProductImgType = "jpg";
    this.googleAnalyticsToken = "";
  }

  initPlugin({
    sessionId,
    apiPath = DEFAULT_API_PATH,
    serviceUrl = apiPath,
    plugin = true,
  }) {
    this.plugin = plugin;
    if (sessionId) this.sessionId = sessionId;
    this.serviceUrl = serviceUrl;
    this.initialized = new Date();
    // console.debug('AppConfig.plugin', { sessionId, serviceUrl }, this);
  }

  init(session) {
    this.staticAssetsEndpoint = session.staticAssetsEndpoint
      ? (session.staticAssetsEndpoint.indexOf("//") === 0 ? "https:" : "") +
        session.staticAssetsEndpoint.replace("http:", "https:")
      : "/";
    //this.sessionId = session.id;
    this.website = session.website;
    this.clientId = session.clientId;
    this.$session = session;
    this.isOffline = session.isOffline();
    this.isShowroom = session.isShowroom();
    this.productImageBase = `${this.staticAssetsEndpoint}productImages/${this.clientId}/`;
    this.productDesignBase = `${onDemandBucketBase}/designs/${this.clientId}/`;
    this.renderingBase = `${onDemandBucketBase}/renderings/${this.clientId}/`;
    this.cacheBuster =
      window.cacheBuster ||
      process.env.fileVersion ||
      session.informationalVersion ||
      session.databaseVersion ||
      "327437";
    //console.warn("AppConfig.init", session, this);
    return this.onInit(session);
  }

  onInit(session) {
    // if (!session.clientId) {
    //   location.href = "#/sync-data?force=1";
    //   window.alert("Houston, we gotta problem.... No Client Id!");
    // }
    return session;
  }

  resolveServiceUrl(route) {
    return `${this.serviceUrl}${route}`;
  }

  normalizeProductID(productId) {
    let result =
      productId && productId.id !== undefined
        ? productId.id
        : productId && productId.productId !== undefined
        ? productId.productId
        : productId;
    if (result) {
      return (result || "").toString().replace("/", "$FORWARDSLASH$");
    }
  }

  transparency(id) {
    return `${this.staticAssetsEndpoint}productImages/${clipartClient}/transparent/${id}.png?${this.cacheBuster}=no-cache`; // TODO: this.clientId
  }

  svg(id) {
    return `${this.productImageBase}svg/${id}.svg?${this.cacheBuster}=no-cache`;
  }

  catalogImg(
    type = "page",
    id,
    size = "small",
    ext = "jpg",
    cacheBuster = "&"
  ) {
    if (this.isOffline) return this.altCatalogImg(type, id);
    return `${this.productImageBase}covers/${type}s/${
      size || this.defaultProductSize
    }/${id}.${ext || "jpg"}?${this.cacheBuster}=no-cache&${cacheBuster}`;
  }

  altCatalogImg(
    type = "page",
    id,
    size = "small",
    ext = "jpg",
    cacheBuster = "&"
  ) {
    // TODO: Offline "/service/GetProductCatalogPageImage/" + p.id;
    // TODO: Offline "/service/GetProductCatalogSectionCoverImage/" + p.id;
    // TODO: Offline "/service/GetProductCatalogCoverImage/" + p.id;
    return `${this.serviceUrl}GetProductCatalog${
      type === "catalog"
        ? "Cover"
        : type === "section"
        ? "SectionCover"
        : "Page"
    }Image/${id}?${this.cacheBuster}=no-cache&${cacheBuster}`;
  }

  productImage(productId, size, ext, cacheBuster = "&") {
    return `${this.productImageBase}${
      size || this.defaultProductSize
    }/${this.normalizeProductID(productId)}.${ext || "jpg"}?${
      this.cacheBuster
    }=no-cache&${cacheBuster}`;
  }

  localProductImage(productId, size, ext, cacheBuster = "&") {
    return `${this.serviceUrl}productImages/${
      size || this.defaultProductSize
    }/${this.normalizeProductID(productId)}.${ext || "jpg"}?${
      this.cacheBuster
    }=no-cache&${cacheBuster}`;
  }

  alternateImage(productId, position, size, ext, cacheBuster = "&") {
    if (position <= 1) return this.productImage(productId, size, ext);
    return `${this.productImageBase}${
      size || this.defaultProductSize
    }/${this.normalizeProductID(productId)}_${position}.${ext || "jpg"}?${
      this.cacheBuster
    }=no-cache&${cacheBuster}`;
  }

  localAlternateImage(productId, position, size, ext, cacheBuster = "&") {
    return `${this.serviceUrl}productImages/${
      size || this.defaultProductSize
    }/${this.normalizeProductID(productId)}_${position}.${ext || "jpg"}?${
      this.cacheBuster
    }=no-cache&${cacheBuster}`;
  }

  renderingImage(id, size, ext, cacheBuster = "&") {
    return `${this.renderingBase + id}/${size || this.defaultProductSize}.${
      ext || "jpg"
    }?${this.cacheBuster}=no-cache&${cacheBuster}`;
  }

  rendering(id, cacheBuster = "&") {
    return `${this.renderingBase + id}/design.json?${
      this.cacheBuster
    }=no-cache&${cacheBuster}`;
  }

  designImage(id, size, cacheBuster = "&") {
    return `${this.productDesignBase + id}/${
      size || this.defaultProductSize
    }.png?${this.cacheBuster}=no-cache&${cacheBuster}`;
  }

  design(id, name, ext, cacheBuster = "&") {
    return `${this.productDesignBase + id}/${name || "design"}.${
      ext || "json"
    }?${this.cacheBuster}=no-cache&${cacheBuster}`;
  }

  clipartImage(id, size) {
    return this.designImage(id, size).replace(this.clientId, clipartClient);
  }

  clipart(id) {
    return this.design(id).replace(this.clientId, clipartClient);
  }
}
